import { z } from 'zod/v4';

import { createEnumSchemaPreprocessor } from '../../../utils/create-enum-schema-preprocessor';

export const avoidFavorTypes = ['avoid', 'favor'] as const;

export const avoidFavorTypeSchema = createEnumSchemaPreprocessor(
  z.enum(avoidFavorTypes),
  ['n/a', 'avoid', 'favor']
);

export type AvoidFavorType = z.infer<typeof avoidFavorTypeSchema>;
